<template>
	<div class="section">
		<div class="profile_page">
			<b-overlay :show="isLoading">
				<div v-if="error" class="error">
					<h5>{{ error }}</h5>
				</div>
				<div v-if="errors.length > 0">
					<div class="error" v-for="(error_sub, index) in errors" :key="index">{{ error_sub }}</div>
				</div>
				<div v-if="!response" class="success">
					<h4>Пользователь активирован</h4>
					<b-button variant="primary" :href="cas_url" onclick="this.blur();" style="float: right;">Войти в систему</b-button>
				</div>
			</b-overlay>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { REGISTER_CONFIRM } from '@/store/actions.type'

export default {
	name: 'RegisterConfirm',
	props: ['uid', 'token'],
	data () {
		return {
			response: null,
			error: null,
			cas_url: process.env.CAS_URL + "/login?locale=ru&service=" + process.env.VIEWER_URL
		}
	},
	created () {
		this.fetchData()
	},
	watch: {
		'$route': 'fetchData'
	},
	computed: {
		...mapGetters({
			isLoading: 'registerConfirmIsLoading',
			errors: 'registerConfirmIsLoading'
		})
	},
	methods: {
		fetchData () {
			if (this.uid && this.uid.length > 0 && this.token && this.token.length > 0) {
				this.$store.dispatch(REGISTER_CONFIRM, { uid: this.uid,	token: this.token })
				.then((data) => {
					this.response = data === true ? true : false
					this.error = data === true ? null : "Неверно указаны данные"
				})
			} else {
				this.error = "Неверно указаны данные"
			}
		}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/Register/Confirm.vue